import { updateGlobalSettings } from "./settings";
import { singularityStore } from "@/store/store";
import {
  BORDER_RADIUS_VALUES,
  ButtonStylePayload,
  FormStylePayload
} from "@/types/singularity/brand";
import { UnitInputValue } from "@/types/unit";

export function updateGlobalButtonStyles(payload?: ButtonStylePayload): void {
  const brandColors = singularityStore.brand.color;

  const internalRadius =
    payload && payload.radius
      ? payload.radius
      : singularityStore.brand.ui.inputRadius;

  const internalSize =
    payload && payload.size
      ? payload.size
      : singularityStore.brand.ui.buttonSize;

  const styles = {
    value: {
      primary: {
        corners: "custom",
        corner_radius: BORDER_RADIUS_VALUES[internalRadius],
        background: `var(--${brandColors.primary?.base.cssVariableName})`,
        background_hover: `var(--${brandColors.primary?.scale[600].cssVariableName})`,
        typography: {
          color: `var(--${brandColors.primary?.text.cssVariableName})`
        },
        size: {
          size: {
            breakpoint_base: "custom"
          },
          padding: CONTROL_PADDING[internalSize].style
        }
      },
      secondary: {
        corners: "custom",
        corner_radius: BORDER_RADIUS_VALUES[internalRadius],
        outline: "true",
        background_hover: "transparent",
        color: `var(--bde-body-text-color)`,
        typography: {
          color: `var(--bde-body-text-color)`
        },
        size: {
          size: {
            breakpoint_base: "custom"
          },
          padding: CONTROL_PADDING[internalSize].style
        }
      }
    }
  };

  updateGlobalSettings("settings.buttons", {
    ...styles.value
  });
}

export function updateGlobalFormStyles(payload: FormStylePayload): void {
  const internalRadius =
    payload && payload.radius
      ? payload.radius
      : singularityStore.brand.ui.inputRadius;

  const style = {
    value: {
      fields: {
        borders: {
          radius: {
            all: BORDER_RADIUS_VALUES[internalRadius]
          }
        }
      }
    }
  };

  updateGlobalSettings("settings.forms", {
    ...style.value
  });
}

export function inputValueInPixels(number: number): UnitInputValue {
  return {
    number: number,
    unit: "px",
    style: `${number}px`
  };
}

function generatePadding(y: number, x: number) {
  return {
    breakpoint_base: {
      top: inputValueInPixels(y),
      right: inputValueInPixels(x),
      bottom: inputValueInPixels(y),
      left: inputValueInPixels(x)
    }
  };
}

export const CONTROL_PADDING = {
  default: { style: generatePadding(14, 24), string: "14px 24px" },
  sm: { style: generatePadding(12, 16), string: "12px 16px" },
  md: { style: generatePadding(16, 32), string: "16px 32px" },
  lg: { style: generatePadding(20, 40), string: "20px 40px" }
};
